/**
 * Theme 100 (`_theme.100.css`) is always on.
 *
 * Existing callers still pass the shell `THEME_CHANGED` message,
 * `?__v3singleTheme=1`, and the `aos-single-theme` session value. Those inputs
 * are ignored so none of them can switch the app back to a product theme.
 */

export const SINGLE_THEME_ID = 100;

export const SINGLE_THEME_PARAM = '__v3singleTheme';

type SingleThemeListener = (enabled: boolean) => void;

const listeners = new Set<SingleThemeListener>();

export function isSingleThemeMode(): boolean {
  return true;
}

/** Subscribes to single-theme changes. Theme 100 does not emit changes. */
export function subscribeSingleThemeMode(
  listener: SingleThemeListener,
): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function setSingleThemeMode(_enabled: boolean): void {
  return;
}

/** Kept for startup callers. Always reports theme 100 as on. */
export function initSingleThemeModeFromUrl(): boolean {
  return true;
}

if (typeof document !== 'undefined') {
  document.documentElement.dataset.theme = String(SINGLE_THEME_ID);
}
